/** PROTOTYPE — mock Wheeler-shaped reconciliation rows. Delete with prototype folder. */

export const MOCK_HRP_SNAPSHOT = {
    asOfDate: "2026-01-01",
    components: [
        { billingRateComponentName: "WHEEL Medical Administration", billingMethod: "PMPM" },
        { billingRateComponentName: "WHEEL Network Access Fee: Cigna", billingMethod: "PEPM" },
        { billingRateComponentName: "WHEEL Legacy Stoploss Fee", billingMethod: "PEPM" },
        { billingRateComponentName: "WHEEL Specialty RX", billingMethod: "PMPM" },
    ],
};

export const createMockReconciliationRows = () => [
    {
        rowId: "extracted-0",
        matchType: "fuzzy+renewal",
        hrpComponentName: "WHEEL Medical Administration",
        hrpBillingMethod: "PMPM",
        hrpCurrentAmount: "2.35",
        extractedFeeDescription: "Medical Admin",
        extractedName: "WHEEL Medical Admin",
        extractedAmount: "2.35",
        renewalNewAmount: "2.50",
        renewalFeeIndex: 0,
        extractedFeeType: "PMPM",
        suggestedAction: "amend",
        matchScore: 0.78,
        nameMismatch: true,
        confirmed: false,
        skipped: false,
        userAction: null,
    },
    {
        rowId: "extracted-1",
        matchType: "exact+renewal",
        hrpComponentName: "WHEEL Network Access Fee: Cigna",
        hrpBillingMethod: "PEPM",
        hrpCurrentAmount: "1.10",
        extractedFeeDescription: "Network Access Fee: Cigna",
        extractedName: "WHEEL Network Access Fee: Cigna",
        extractedAmount: "1.10",
        renewalNewAmount: "1.25",
        renewalFeeIndex: 1,
        extractedFeeType: "PEPM",
        suggestedAction: "amend",
        matchScore: 1,
        nameMismatch: false,
        confirmed: false,
        skipped: false,
        userAction: null,
    },
    {
        rowId: "extracted-2",
        matchType: "exact",
        hrpComponentName: "WHEEL Specialty RX",
        hrpBillingMethod: "PMPM",
        hrpCurrentAmount: "0.85",
        extractedFeeDescription: "Specialty RX",
        extractedName: "WHEEL Specialty RX",
        extractedAmount: "0.85",
        renewalNewAmount: null,
        renewalFeeIndex: null,
        extractedFeeType: "PMPM",
        suggestedAction: "amend",
        matchScore: 1,
        nameMismatch: false,
        confirmed: false,
        skipped: false,
        userAction: null,
    },
    {
        rowId: "hrp-legacy",
        matchType: "hrp-only",
        hrpComponentName: "WHEEL Legacy Stoploss Fee",
        hrpBillingMethod: "PEPM",
        hrpCurrentAmount: "0.40",
        extractedFeeDescription: null,
        extractedName: null,
        extractedAmount: null,
        renewalNewAmount: null,
        renewalFeeIndex: null,
        extractedFeeType: null,
        suggestedAction: "skip",
        matchScore: null,
        nameMismatch: false,
        confirmed: false,
        skipped: false,
        userAction: null,
    },
    {
        rowId: "hrp-renewal",
        matchType: "hrp-only+renewal",
        hrpComponentName: "WHEEL Legacy Stoploss Fee",
        hrpBillingMethod: "PEPM",
        hrpCurrentAmount: "0.40",
        extractedFeeDescription: "Stoploss Admin",
        extractedName: null,
        extractedAmount: null,
        renewalNewAmount: "0.45",
        renewalFeeIndex: 2,
        extractedFeeType: "PEPM",
        suggestedAction: "amend",
        matchScore: 0.81,
        nameMismatch: true,
        confirmed: false,
        skipped: false,
        userAction: null,
    },
    {
        rowId: "renewal-3",
        matchType: "renewal-only",
        hrpComponentName: null,
        hrpBillingMethod: null,
        hrpCurrentAmount: null,
        extractedFeeDescription: "New Vendor PEPM",
        extractedName: null,
        extractedAmount: null,
        renewalNewAmount: "0.75",
        renewalFeeIndex: 3,
        extractedFeeType: "PEPM",
        suggestedAction: "create",
        matchScore: null,
        nameMismatch: false,
        confirmed: false,
        skipped: false,
        userAction: null,
    },
    {
        rowId: "extracted-only",
        matchType: "extracted-only",
        hrpComponentName: null,
        hrpBillingMethod: null,
        hrpCurrentAmount: null,
        extractedFeeDescription: "Claims Platform Fee",
        extractedName: "WHEEL Claims Platform Fee",
        extractedAmount: "0.15",
        renewalNewAmount: null,
        renewalFeeIndex: null,
        extractedFeeType: "PEPM",
        suggestedAction: "create",
        matchScore: null,
        nameMismatch: false,
        confirmed: false,
        skipped: false,
        userAction: null,
    },
];

export const VARIANT_META = {
    A: { label: "A — Inline actions", description: "Table with Update / Keep HRP / Ignore per row" },
    B: { label: "B — Grouped review", description: "Review / Ready / Resolved sections; Keep primary on fuzzy" },
    C: { label: "C — Expandable diff", description: "Side-by-side HRP vs Extracted vs New in expanded rows" },
};

export const VARIANT_KEYS = Object.keys(VARIANT_META);
